module.exports = __webpack_public_path__ + "static/meadows-detail2-866ee8f3a66fb15828131f512beb9888.jpg";